import { Button } from '@westhetics/ui'
import type { ManualMessage } from './use-signature-actions'

/** O botão "Abrir WhatsApp" e "Copiar link" do WhatsApp assistido, para o painel e a etapa 3. */
export function ManualLinkActions({
  message,
  onOpen,
  onCopyLink,
  onCopyMessage,
}: {
  message: ManualMessage
  onOpen: (message: ManualMessage) => void
  onCopyLink: (link: string) => void
  onCopyMessage: (text: string) => void
}) {
  return (
    <div className="flex flex-wrap gap-3">
      {message.whatsapp ? (
        <Button variant="outline" size="sm" onClick={() => onOpen(message)}>
          Abrir WhatsApp
        </Button>
      ) : null}
      <Button variant="text" size="sm" onClick={() => onCopyMessage(message.text)}>
        Copiar mensagem
      </Button>
      <Button variant="text" size="sm" onClick={() => onCopyLink(message.link)}>
        Copiar link
      </Button>
    </div>
  )
}
